export const QA_QUESTIONS = '/qa'
export const QA_QnA = `${QA_QUESTIONS}/:id`

export const qaAnswer = questionID => QA_QnA.replace(':id', questionID)
